import React, { useEffect, useState, useCallback, useRef } from 'react';
import axios from 'axios';
import './index.scss'; // 假设有样式文件
import { TimeIcon, FromIcon, ToIcon } from '../../components/Icons';
import { useHistory } from 'react-router-dom'; // 替换 useNavigate
import QRCode from 'qrcode.react'; // 导入QRCode组件
import request from '@/utils/request'; // 导入request
import { createNonceStr, md5, getLocationSearch } from "@/utils/utils"; // 添加必要的工具函数导入

const QRCodeModal = ({ visible, orderId, onClose }) => {
  if (!visible) return null;
  let url =`/home/pages/offlineOrder/index?outOrderId=${orderId}`
  
  return (
    <div className="qrcode-modal-overlay">
      <div className="qrcode-modal">
        <div className="qrcode-modal-header">
          <h3>订单二维码</h3>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>
        <div className="qrcode-modal-body">
          <div className="qrcode-container">
            <QRCode 
              value={`https://kplx-ry-h5-biz-test.kunpengchuxing.com/TAYC?url=${encodeURIComponent(url)}`} // 使用encodeURIComponent对URL进行编码
              size={300}
              renderAs="svg"
            />
          </div>
          <p>订单号: {orderId}</p>
          <p>请用微信扫码</p>
        </div>
      </div>
    </div>
  );
};

const OfflineOrderList = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [qrCodeVisible, setQrCodeVisible] = useState(false);
  const [selectedOrderId, setSelectedOrderId] = useState(null);
  const [pageNo, setPageNo] = useState(1); // 添加页码状态
  const [pageSize, setPageSize] = useState(10); // 添加每页大小状态
  const [hasMore, setHasMore] = useState(true); // 是否还有更多数据
  const listRef = useRef(null); // 添加列表引用，用于滚动监听
  const history = useHistory(); // 替换 useNavigate
  // 添加下拉刷新相关状态
  const [refreshing, setRefreshing] = useState(false);
  const [startY, setStartY] = useState(0);
  const [pullDistance, setPullDistance] = useState(0);
  const pullThreshold = 80; // 下拉阈值，超过这个距离触发刷新

  // 添加基础参数构建逻辑
  let token = getLocationSearch().token;
  let appKey = "app_h5";
  let secret = "11dc72cf-88b0-46cd-91d7-b1a77fd69ee1";
  let timestamp = new Date().getTime();
  let random = createNonceStr();
  let tempStr = `appKey${appKey}secret${secret}timestamp${timestamp}random${random}token${token}`;
  let sign = md5(tempStr, 32).toString(16).toLocaleUpperCase();
  const params = {
    appKey: appKey,
    timestamp: timestamp,
    random: random,
    token: token,
    sign: sign,
  };

  // 获取订单列表数据
  const fetchOrders = async (isLoadMore = false) => {
    // 初始加载时不应该被阻止，只有加载更多时才检查条件
    if (isLoadMore && (loading || !hasMore)) return;
    
    try {
      console.log('开始请求数据', { isLoadMore, pageNo, pageSize });
      setLoading(true);
      
      // 使用真实API请求替代模拟数据
      const response = await request.post('/api/offlineOrder/page', {
        pageNo: isLoadMore ? pageNo : 1, // 如果是加载更多，使用当前页码；否则从第1页开始
        pageSize: pageSize
      }, params); // 添加基础参数
      
      console.log('请求返回数据', response);
      
      if (response?.data && response.data.errorCode === 0) {
        const newOrders = response.data.data?.datas || [];
        
        // 如果是加载更多，则追加数据；否则替换数据
        if (isLoadMore) {
          setOrders(prevOrders => [...prevOrders, ...newOrders]);
        } else {
          setOrders(newOrders);
        }
        
        // 判断是否还有更多数据
        setHasMore(newOrders.length === pageSize);
        
        // 如果是加载更多，则增加页码
        if (isLoadMore) {
          setPageNo(prevPageNo => prevPageNo + 1);
        } else {
          setPageNo(2); // 初次加载后设置为第2页，为下次加载做准备
        }
      } else {
        console.error('获取订单列表失败:', response?.data?.errorMsg || '未知错误');
      }
    } catch (error) {
      console.error('请求失败:', error);
    } finally {
      setLoading(false);
      // 完成刷新后重置刷新状态和下拉距离
      setRefreshing(false);
      setPullDistance(0);
    }
  };

  // 添加下拉刷新相关触摸事件处理函数
  const handleTouchStart = (e) => {
    // 只有在列表顶部时才允许下拉刷新
    if (document.documentElement.scrollTop === 0) {
      setStartY(e.touches[0].clientY);
    }
  };

  const handleTouchMove = (e) => {
    // 只有在列表顶部时才处理下拉操作
    if (startY > 0 && document.documentElement.scrollTop === 0) {
      const currentY = e.touches[0].clientY;
      const distance = currentY - startY;
      
      // 只处理下拉操作，不处理上拉
      if (distance > 0) {
        // 添加阻尼效果，使下拉越来越难
        const dampedDistance = Math.min(distance * 0.5, 120);
        setPullDistance(dampedDistance);
        
        // 防止页面滚动
        e.preventDefault();
      }
    }
  };

  const handleTouchEnd = () => {
    if (pullDistance > pullThreshold && !refreshing && !loading) {
      // 触发刷新
      setRefreshing(true);
      // 重置页码并获取最新数据
      setPageNo(1);
      fetchOrders(false);
    } else {
      // 未达到阈值，重置下拉距离
      setPullDistance(0);
    }
    // 重置起始Y坐标
    setStartY(0);
  };

  // 滚动加载更多数据
  const handleScroll = useCallback(() => {
    if (!listRef.current || loading || !hasMore) return;
    
    const { scrollTop, clientHeight, scrollHeight } = document.documentElement;
    
    // 当滚动到距离底部100px时，加载更多数据
    if (scrollTop + clientHeight >= scrollHeight - 100) {
      fetchOrders(true);
    }
  }, [loading, hasMore, pageNo]);
  
  // 组件挂载时添加滚动监听
  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [handleScroll]);

  useEffect(() => {
    console.log('组件挂载，开始初始化数据');
    fetchOrders(false);  // 明确传入false表示初始加载
  }, []); // 初始加载数据

  const handleCloseOrder = async (orderId) => {
    try {
      setLoading(true);
      // 发送关闭订单请求，状态码0表示已关闭
      const response = await request.post(`/api/offlineOrder/changestatus/${orderId}/0`, {}, params); // 修改状态码为0
      if (response.data && response.data.errorCode === 0) {
        // 更新本地订单状态
        setOrders(orders.map(order => 
          order.orderId === orderId ? { ...order, orderStatus: 0 } : order
        ));
        alert('订单已关闭');
      } else {
        console.error('关闭订单失败:', response.data?.errorMsg || '未知错误');
        alert('关闭订单失败');
      }
    } catch (error) {
      console.error('关闭订单请求失败:', error);
      alert('关闭订单请求失败');
    } finally {
      setLoading(false);
    }
  };

  const handleCompleteOrder = async (orderId) => {
    try {
      setLoading(true);
      // 发送完成订单请求，状态码3表示已完成
      const response = await request.post(`/api/offlineOrder/changestatus/${orderId}/3`, {}, params);
      if (response.data && response.data.errorCode === 0) {
        // 更新本地订单状态
        setOrders(orders.map(order => 
          order.orderId === orderId ? { ...order, orderStatus: 3 } : order
        ));
        alert('订单已完成');
      } else {
        console.error('完成订单失败:', response.data?.errorMsg || '未知错误');
        alert('完成订单失败');
      }
    } catch (error) {
      console.error('完成订单请求失败:', error);
      alert('完成订单请求失败');
    } finally {
      setLoading(false);
    }
  };

  const handleShowQRCode = (orderId) => {
    setSelectedOrderId(orderId);
    setQrCodeVisible(true);
  };

  const handleCloseQRCode = () => {
    setQrCodeVisible(false);
    setSelectedOrderId(null);
  };

  const renderOrderStatus = (status) => {
    switch (status) {
      case 0:
        return '已关闭';
      case 1:
        return '待支付';
      case 2:
        return '进行中';
      case 3:
        return '已完成';
      default:
        return '未知状态';
    }
  };

  if (loading && orders.length === 0) {
    return <div className="loading">加载中...</div>;
  }

  return (
    <div 
      className="offline-order-list" 
      ref={listRef}
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
      onTouchEnd={handleTouchEnd}
    >
      {/* 下拉刷新指示器 */}
      <div 
        className="pull-to-refresh-indicator" 
        style={{ 
          height: `${pullDistance}px`,
          opacity: pullDistance / pullThreshold,
          transition: refreshing ? 'none' : 'height 0.2s ease'
        }}
      >
        {refreshing ? 
          <div className="refresh-spinner"></div> : 
          <div className="pull-arrow" style={{ transform: pullDistance > pullThreshold ? 'rotate(180deg)' : 'rotate(0deg)' }}></div>
        }
        <span>{refreshing ? '刷新中...' : pullDistance > pullThreshold ? '释放刷新' : '下拉刷新'}</span>
      </div>

      <button className="create-order-btn" onClick={() => history.push('/offlineOrder/create')}>
        创建线下订单
      </button>
      {orders.map((order) => (
        <div className="order-card" key={order.orderId}>
          <div className="order-header">
            <span>
              <TimeIcon /> 时间：{order.startTime}
            </span>
            <span>{renderOrderStatus(order.orderStatus)}</span>
          </div>
          <div className="order-body">
            <p>
              <FromIcon /> {order.fromAddress}
            </p>
            <p>
              <ToIcon /> {order.toAddress}
            </p>
          </div>
          <div className="order-footer">
            <p>金额：{order.totalFee}元</p>
          </div>
          <div className="order-actions">
            {order.orderStatus === 1 && (
              <>
                <button onClick={() => handleCloseOrder(order.orderId)}>关闭订单</button>
                <button onClick={() => handleShowQRCode(order.orderId)}>查看二维码</button>
              </>
            )}
            {order.orderStatus === 2 && (
              <button onClick={() => handleCompleteOrder(order.orderId)}>完成订单</button>
            )}
          </div>
        </div>
      ))}

      {loading && orders.length > 0 && (
        <div className="loading-more">加载更多...</div>
      )}
      
      {!hasMore && orders.length > 0 && (
        <div className="no-more-data">已经到底了</div>
      )}

      <QRCodeModal 
        visible={qrCodeVisible}
        orderId={selectedOrderId}
        onClose={handleCloseQRCode}
      />
    </div>
  );
};

export default OfflineOrderList;
